import CONFIRM_DIALOGS from './confirm-dialog/pt';
import ERROR_DIALOGS from "./error-dialog/pt";
import RESULT_DIALOGS from "./result-dialog/pt";

export default {
    BUTTONS: {
        SUBMIT: "Enviar",
        PREVIOUS: "Anterior",
        NEXT: "Próxima",
        VIEW: "Ver",
        UPLOAD: "Upload",
        CLOSE: "Fechar",
        DELETE: "Excluir",
        CANCEL: "Cancelar",
        YES: "Sim",
        NO: "Não",
        OK: "Ok",
        ADD: "Acrescentar"
    },
    OPTIONS: {
        YES: "Sim",
        NO: "Não",
    },
    ERROR_MESSAGES: {
        FIELD_REQUIRED: "Este campo é obrigatório."
    },
    APPLICATION_FORM: {
        WAIT_FOR_PROCESSING: "Processando ... Por favor aguarde...",
        STEP_OF: "Etapa {0} de {1}"
    },
    FILE_UPLOAD: {
        UPLOAD_INSTRUCTION: "Solte um arquivo aqui ou clique para fazer o upload",
        MAXIMUM_UPLOAD_SIZE: "Tamanho máximo de upload {0}MB",
        FILE_EXCEED_MAXIMUM: "O tamanho do arquivo excede {0}MB.",
        FILE: "Arquivo"
    },
    BOOKING_DIALOG: {
        LABEL: {
            REPEAT: "Repete?",
            REPEAT_UNTIL: "Repetir até",
            REPEAT_EVERY: "Repetir a cada",
            REPEAT_ON: "Repetir Ligado",
            BOOKING_ADDRESS: "Endereço de reserva",
            ADDRESS_LINE2: "Linha de endereço 2",
            CITY: "Cidade",
            STATE: "Estado",
            ZIP_CODE: "CEP",
            NUMBER_CHILDREN: "Quantas crianças serão cuidadas?",
            SELECT_JOB_CATEGORY: "Selecione a categoria de trabalho"
        },
        OPTIONS: {
            REPEAT_TYPE: ["Dias", "Semanas"],
            REPEAT_ON: [
                "Segunda-feira",
                "Terça",
                "Quarta-feira",
                "Quinta-feira",
                "Sexta-feira",
                "Sábado",
                "Domingo"
            ]
        }
    },
    CONFIRM_DIALOGS: CONFIRM_DIALOGS,
    ERROR_DIALOGS: ERROR_DIALOGS,
    RESULT_DIALOGS: RESULT_DIALOGS
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/pt.js